import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["boxSize", "color"];
import React from 'react';
import { BaseIcon } from "../../../index.js";
export var CrossOutlined = function CrossOutlined(_ref) {
  var boxSize = _ref.boxSize,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'grey.900' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    w: "16px",
    h: "22px",
    viewBox: "0 0 16 22",
    boxSize: boxSize,
    color: color,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.0528 6.96056L11.9921 5.8999L7.99213 9.8999L3.99213 5.8999L2.93147 6.96056L6.93147 10.9606L2.7998 15.0922L3.86047 16.1529L7.99213 12.0212L12.1238 16.1529L13.1844 15.0922L9.05279 10.9606L13.0528 6.96056Z",
    fill: "#E20019"
  }));
};